module.exports = __webpack_public_path__ + "static/img/18.99ab637.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/18.jpg
// module id = 75dX
// module chunks = 1